<div class="header">
    <h3>{{ 'catalog.tags.title' | translate}} </h3>
    <div class="header-actions">
        <div class="actions-container" *ngIf="!loading">
            <txp-button [style]="buttonStyle.SECONDARY"
                        [size]="buttonSize.SMALL"
                        data-qa-label="AddTagButton"
                        [disabled]="tagButtonDisabled"
                        (click)="handleAddTag()">
                + {{ 'catalog.tags.addTag' | translate }}
            </txp-button>
        </div>
    </div>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="loading"></txp-loading>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                    data-qa-label="PageErrorMessage"
                    *ngIf="showError">
        {{ 'catalog.association.loadingAssociationsErrorMsg' | translate }}
    </txp-message>
</div>

<div class="tag-assoc-content" *ngIf="!loading">

    <div class="form-content">
        <txp-change-set-notice
          [activeVersion]="selectedVersion"
          [itemChanges]="itemChanges"
          [customDecider]="hasFieldChanged.bind(this)"
          [noticeAlign]="'top'"
          [noticeType]="'icon'"
          [eventDetail]="'tags'">
            <div class="tag-assoc-list"
                 *ngIf="form.get('tagIds').value; let tagAssociationList">
                    <div class="tag-title" *ngIf="getFilteredTags()"></div>

                <table mat-table
                       [dataSource]="dataSource"
                       matSort
                       matSortActive="name"
                       matSortDirection="desc"
                       matSortDisableClear
                       class="tag-assoc-content">

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'catalog.tags.name' | translate }} </th>
                        <td mat-cell *matCellDef="let assoc"> {{ assoc?.name }} </td>
                    </ng-container>

                    <!-- Type Column -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'catalog.tags.tagType' | translate }} </th>
                        <td mat-cell *matCellDef="let assoc"> {{ 'catalog.tags.' + assoc?.type.toLowerCase() | translate }} </td>
                    </ng-container>

                    <!-- Start Date Column -->
                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'catalog.tags.startDate' | translate }} </th>
                        <td mat-cell *matCellDef="let assoc">
                            <span *ngIf="assoc?.startDate">{{ assoc?.startDate | date: 'MM/dd/yyyy' }}</span>
                        </td>
                    </ng-container>

                    <!-- End Date Column -->
                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'catalog.tags.endDate' | translate }} </th>
                        <td mat-cell *matCellDef="let assoc">
                            <span *ngIf="assoc?.endDate">{{ assoc?.endDate | date: 'MM/dd/yyyy' }}</span>
                        </td>
                    </ng-container>

                    <!-- Delete Button Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let assoc">
                            <txp-button data-qa-label="RemoveButton" [style]="buttonStyle.ROWACTION" icon="tce-icon-trash"
                                [attr.title]="'form.button.remove' | translate" (click)="onDelete(assoc)"
                                [disabled]="(isReadOnly$ | async) === true">
                            </txp-button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </txp-change-set-notice>
    </div>

</div>
